import { http } from "~/utils";
export default {
    getVendors: async (page = 1, filters = {}) => {
        const request_filters = { ...filters, page };
        return http.get("/suppliers/company/", { params: request_filters }).then(response => ({
            list: response.data.results,
            pagination: {
                actual: response.data.actual,
                count: response.data.count,
                next: response.data.next,
                pages: response.data.pages,
                previous: response.data.previous
            }
        }));
    },
    requestReport: async () => {
        return await http.post("/suppliers/company/report/").then(response => response.data);
    },
    getContractList: async (search = null) => {
        return await http
            .get(`/contract_management/contract/`, {
                params: {
                    search
                }
            })
            .then(response => response.data.results);
    },
    getContractLines: async (contract = null) => {
        return await http
            .get(`/contract_management/contract-line/`, {
                params: {
                    contract
                }
            })
            .then(response => response.data.results);
    },
    getContractLinesByContractNumber: async (contract__number = null) => {
        return await http
            .get(`/contract_management/contract-line/`, {
                params: {
                    contract__number
                }
            })
            .then(response => response.data.results);
    },
    contractReport: async contract => {
        return await http
            .post(`/contract_management/contract/${contract.id}/contract-report/`, {}, { responseType: "blob" })
            .then(response => {
                const filename = `${contract.number}.xlsx`;
                if (response) {
                    const link = document.createElement("a");
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    link.href = url;
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                }
            });
    }
};
